import { render } from "./MobileHeader.vue?vue&type=template&id=48c014db&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=48c014db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c014db"]])

export default __exports__